// extracted by mini-css-extract-plugin
module.exports = {"card":"ComplexCard_card__1i1H3"};